export const HOME_URI = '__home__';
